module.exports = __webpack_public_path__ + "img/ascend.663cd390.png";